<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { NewsletterSubscriptionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: { id: string; form: NewsletterSubscriptionRecord } }>();
</script>

<template>
  <div v-if="data?.form" class="mb-3xl lg:mb-5xl relative">
    <Vector class="vector--background-light absolute left-[-25px] top-[-50px] z-0 hidden h-[354px] w-[340px] rotate-0 lg:block" />

    <div class="bg-primary-200 relative z-10 mx-auto w-full rounded-lg shadow-[0px_0px_45px_0px_#ECAFB6] xl:w-4/5">
      <div class="flex items-end">
        <DatocmsImage
          v-if="data.form.optImage"
          :data="data.form.optImage!.responsiveImage as ResponsiveImageType"
          :lazy-load="false"
          object-fit="contain" class="hidden! h-[290px] w-1/6 lg:block!"
        />

        <div class="p-lg md:px-3xl md:py-4xl relative w-full overflow-hidden lg:w-5/6">
          <Vector class="vector--background-primary absolute bottom-[-25px] right-[50px] z-20 h-51 w-52 rotate-50" />

          <div class="relative z-30">
            <h3 class="mb-xs">
              {{ data.form.title }}
            </h3>

            <p class="mb-lg" v-html="data.form.text" />

            <FormNewsletterSubscription :form="data.form" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.vector--background-light {
  --esc-vector-fill-color: #f3f1ec;
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
}

.vector--background-primary {
  --esc-vector-fill-color: #de7272;
  --esc-vector-opacity: 0.2;
  --esc-vector-mix-blend-mode: normal;
}
</style>
